<template>

    <b-row>

        <b-col md="6">

            <b-card
                header="Find Templates"
                header-text-variant="white"
                header-bg-variant="info">

                <b-row class="mb-2">

                    <b-col sm="6" md="6" class="my-1">

                        <carrier-dropdown v-model=" ltc_carrier_id "></carrier-dropdown>
                    </b-col>
                    <b-col sm="6" md="6" class="my-1">

                        <b-form-select v-model=" status ">

                            <option value="">-- Show Active --</option>
                            <option value="archived">Include Archived</option>
                        </b-form-select>
                    </b-col>
                </b-row>
                <b-row class="mb-3">

                    <b-col sm="12" class="d-flex align-items-center justify-content-end">

                        <b-button variant="info" @click=" loadTable() ">Generate</b-button>
                    </b-col>
                </b-row>

                <div class="table-responsive">

                    <b-table bordered striped hover show-empty
                        :items=" items "
                        :fields=" fields "
                        :current-page=" currentPage "
                        :per-page=" 0 "
                        :sort-by.sync=" sortBy "
                        :sort-desc.sync=" sortDesc "
                        :busy=" loading "
                    >

                        <template v-slot:cell(status)="row">

                            <p v-if=" row.item.trashed " class="m-0 text-danger">Archived</p>
                            <p v-else class="m-0 text-info">Active</p>
                        </template>

                        <template v-slot:cell(actions)="row">

                            <b-btn v-b-tooltip.hover title="Edit Template" class="mr-1" size="sm" variant="info" @click=" setForm( row.item ) "><i class="fa fa-edit"></i></b-btn>

                            <b-btn v-if=" row.item.trashed " v-b-tooltip.hover title="Restore Template" class="mr-1" size="sm" variant="success" @click=" restoreTemplate( row.item.id ) "><i class="fa fa-recycle"></i></b-btn>
                            <b-btn v-else v-b-tooltip.hover title="Archive Template" class="mr-1" size="sm" variant="danger" @click=" deleteTemplate( row.item.id ) "><i class="fa fa-ban"></i></b-btn>
                        </template>
                    </b-table>
                </div>

                <b-row>

                    <b-col lg="6" >

                        <b-pagination :total-rows=" totalRows " :per-page=" perPage " v-model=" currentPage " />
                    </b-col>
                    <b-col lg="6" class="text-right">

                        {{ paginationText }}
                    </b-col>
                </b-row>
            </b-card>
        </b-col>
        <b-col md="6">

            <b-card
                header="Template Manager"
                header-text-variant="white"
                header-bg-variant="info">

                <b-row>

                    <b-col>

                        <b-form-group label="Carrier Block" label-for="ltc_carrier_id">

                            <carrier-dropdown v-model=" template.ltc_carrier_id " id="ltc_carrier_id" name="ltc_carrier_id"></carrier-dropdown>
                            <input-help :form=" template " field="ltc_carrier_id" text=""></input-help>
                        </b-form-group>
                    </b-col>
                    <b-col>

                        <b-form-group label="Title" label-for="title">

                            <b-form-input
                                id="title"
                                name="title"
                                type="text"
                                v-model="template.title"
                            >
                            </b-form-input>
                            <input-help :form=" template " field="title" text=""></input-help>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>

                    <b-col>

                        <b-form-group :label=" templateLabel " label-for="body">

                            <b-form-textarea
                                id="body"
                                name="body"
                                :rows=" 5 "
                                v-model=" template.body "
                            ></b-form-textarea>
                            <input-help :form=" template " field="body" text="Consider the length of variables used as well"></input-help>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>

                    <b-col sm="3" class="d-flex align-items-center">

                        <p v-if=" template.trashed " class="m-0 text-danger">Archived</p>
                        <p v-else class="m-0 text-info">Active</p>
                    </b-col>
                    <b-col class="d-flex align-items-center justify-content-end">

                        <b-button class="ml-1" variant="default" :disabled=" actionLoading" @click=" setForm() ">Clear Form</b-button>

                        <b-button v-if=" template.trashed " class="ml-1" variant="success" :disabled=" actionLoading || !template.id " @click=" restoreTemplate( template.id ) ">Restore</b-button>
                        <b-button v-else class="ml-1" variant="danger" :disabled=" actionLoading || !template.id " @click=" deleteTemplate( template.id ) ">Archive</b-button>

                        <b-button class="ml-1" variant="info" :disabled=" actionLoading" @click=" saveTemplate() ">Save</b-button>
                    </b-col>
                </b-row>
            </b-card>

            <b-card
                header="Variable Manager"
                header-text-variant="white"
                header-bg-variant="info">

                <text-template-variable-manager></text-template-variable-manager>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>

    import PaginatedTable from "../../mixins/PaginatedTable";
    import FormatsDates from "../../mixins/FormatsDates";

    export default {

        mixins: [ PaginatedTable, FormatsDates ],
        data() {

            return {

                actionLoading      : false,
                template           : new Form({}),

                perPage          : 10,
                baseUrl          : '/business/text_templates',

                status           : '',
                ltc_carrier_id   : '',

                fields : [

                    {
                        key: 'title',
                        label: 'Title',
                        sortable: true
                    },
                    {
                        key: 'carrier_initials',
                        label: 'Block',
                        sortable: true 
                    },
                    {
                        key: 'status',
                        label: 'Status',
                        sortable: true
                    },
                    {
                        key: 'actions',
                        class: 'hidden-print',
                        sortable: false
                    },
                ],
            }
        },

        computed: {

            appliedFilters(){ return `?ltc_carrier_id=${this.ltc_carrier_id}&status=${this.status}`; },
            templateLabel(){

                let length = this.template.body ? this.template.body.length : 0;
                return `Template Body: ${length}/160 characters`;
            }
        },

        methods: {

            setForm( selected = null ){

                this.template = new Form({

                    id             : selected ? selected.id : null,
                    ltc_carrier_id : selected ? selected.ltc_carrier_id : '',
                    title          : selected ? selected.title : '',
                    body           : selected ? selected.body : '',
                    trashed        : selected ? selected.trashed : false,
                });
            },
            deleteTemplate( id ){

                this.actionLoading = true;
                let form = new Form({});

                form.submit( 'delete', `${this.baseUrl}/${id}` )
                    .then( res => {

                        if( this.template.id && this.template.id == id ) this.template.trashed = !this.template.trashed;
                    })
                    .finally( () => {

                        this.actionLoading = false;
                        this.loadTable();
                    })
            },
            restoreTemplate( id ){

                this.actionLoading = true;
                let form = new Form({});

                form.submit( 'patch', `${this.baseUrl}/${id}/restore` )
                    .then( res => {

                        if( this.template.id && this.template.id == id ) this.template.trashed = !this.template.trashed;
                    })
                    .finally( () => {

                        this.actionLoading = false;
                        this.loadTable();
                    })
            },
            saveTemplate(){

                this.actionLoading = true;
                const action = this.template.id ? 'patch' : 'post';
                const url = this.baseUrl + ( this.template.id ? `/${this.template.id}` : '' );

                console.log( this.template );

                this.template.submit( action, url )
                    .then( res => {

                        if( !this.template.id ) this.template.id = res.data.data.id;
                    })
                    .finally( () => {

                        this.loadTable();
                        this.actionLoading = false;
                    })
            }
        },

        mounted(){

            this.setForm();
        }
    }
</script>

<style>

</style>